import { Card as AntCard, Typography } from 'antd';
import { UTable } from '@components/common/UTable/UTable';
import React from 'react';
import { DateTimeFormat } from '@/utils/dateUtils';
import dayjs from 'dayjs';
import {
  drugExpenseColumns,
  tasksTableColumns,
} from '@/pages/Pharmacy/components/Monitoring/expenseModal.config';
import { mapTableIndexWithPage } from '@/utils/utils';

export type TaskDrug = {
  id: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  drugId: string;
  drugBatchId: string;
  name: string;
  batchNumber: string;
  expirationDate: string;
  packagesAmount: number;
  packageVolume: number;
  usedVolume: number;
};
export type DrugBatch = {
  id: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  organizationId: string;
  drugId: string;
  batchNumber: string;
  receiptDate: string;
  expirationDate: string;
  packagesAmount: number;
  packageVolume: number;
  status: string;
  drugBatchId: string;
  usedPackages: number;
};

export type Drug = {
  id: string;
  organizationId: string;
  batches: DrugBatch[];
};

type ExpenseModalContentProps = {
  tasks: TaskDrug[] | [];
  drugs: Drug[] | [];
  setDrugs: React.Dispatch<React.SetStateAction<any[]>>;
  drugDictionary: any[];
  loading: boolean;
  displayEditButton: boolean;
};

export const ExpenseModalContent = ({
  tasks,
  drugs,
  drugDictionary,
  setDrugs,
  loading = false,
  displayEditButton,
}: ExpenseModalContentProps) => {
  const updateUsedPackages = (data: any[], batchId: string, nextUsedPackages: number) => {
    return data.map((item) => ({
      ...item,
      batches: item.batches.map((batch: any) =>
        batch.drugBatchId === batchId
          ? { ...batch, usedPackages: nextUsedPackages }
          : batch,
      ),
    }));
  };

  const updatePackagesAmount = (batchId: string, value: number) => {
    setDrugs((prev: any[]) => updateUsedPackages(prev, batchId, value));
  };

  const batchNumbers = tasks?.map((item) => item?.batchNumber);

  return (
    <>
      <Typography.Title level={3} className={'modal-title'}>
        Списание ветеринарных препаратов {dayjs().format(DateTimeFormat.DATE)}
      </Typography.Title>
      <UTable
        size={'small'}
        columns={tasksTableColumns}
        data={mapTableIndexWithPage(tasks)}
        loading={loading}
        className={'tasks-table'}
      />

      {drugs?.map((drug: any) => (
        <div>
          <AntCard
            size="small"
            variant="borderless"
            title={
              <div className={'title-wrapper'}>
                {drugDictionary?.find((i: any) => i?.id === drug?.id)?.name}
              </div>
            }
            className={'drug-card'}
            classNames={{ header: 'drug-card-header', body: 'drug-card-body' }}>
            <UTable
              size={'small'}
              data={drug?.batches}
              columns={drugExpenseColumns(updatePackagesAmount, displayEditButton)}
              loading={loading}
              className={'drug-expense-table'}
              rowClassName={(record: any) =>
                batchNumbers?.includes(record?.batchNumber) ? 'row-warning-batch' : ''
              }
            />
          </AntCard>
        </div>
      ))}
    </>
  );
};
